export const PreviousName = 'PreviousComponent';
